import React, { useState, useEffect } from 'react';
import {
  Box,
  DialogActions,
  Divider,
  Button,
  makeStyles
} from '@material-ui/core';
import DateFnsUtils from '@date-io/date-fns';
import { MuiPickersUtilsProvider, DatePicker } from '@material-ui/pickers';
import moment from 'moment';
import { getDateValues, getFiscalYearRange } from './utils';

const useStyles = makeStyles({
  year: {
    '& .MuiPickersBasePicker-pickerView': {
      width: '100%',
      maxWidth: 'none',
      minWidth: 0,
      '& .MuiPickersYearSelection-container': {
        padding: '0 1em',
        display: 'flex',
        gap: '2em 4em',
        flexWrap: 'wrap',
        justifyContent: 'space-evenly',
        alignItems: 'stretch',
        overflowY: 'initial',
        '& .MuiPickersYear-yearSelected': {
          margin: 0,
          fontWeight: 700
        }
      },
      '& .MuiPickersMonthSelection-container': {
        width: '100%'
      }
    },
    '& .MuiToolbar-root': {
      width: '180px'
    }
  }
});

// Year-like picker that returns fiscal-year range based on fiscalStartMonth (1-12)
const Fiscal = ({
  handleChangeDatePickerValue,
  handleCloseDialog,
  dateValues,
  prefixText,
  fiscalStartMonth = 1
}) => {
  const classNames = useStyles();
  const [date, setDate] = useState(() =>
    moment(dateValues?.dt1 || moment()).format('YYYY-MM-DD')
  );

  useEffect(() => {
    setDate(moment(dateValues?.dt1 || moment()).format('YYYY-MM-DD'));
  }, [dateValues?.dt1]);

  const handleChange = val => {
    setDate(moment(val).format('YYYY-MM-DD'));
  };

  const handleOk = () => {
    const selectedYear = moment(date).year();
    const startMonth = Number(fiscalStartMonth) || 1;
    const { start, end } = getFiscalYearRange({
      year: selectedYear,
      startMonth
    });

    handleChangeDatePickerValue(
      getDateValues.range({
        values: { dt1: start, dt2: end },
        prefixText: prefixText || 'fiscal_year'
      })
    );
    handleCloseDialog();
  };

  return (
    <>
      <MuiPickersUtilsProvider utils={DateFnsUtils}>
        <Box display="flex" className={classNames.year}>
          <DatePicker
            label="Select Year"
            variant="static"
            orientation="landscape"
            openTo="year"
            views={['year']}
            value={date}
            onChange={handleChange}
            allowKeyboardControl
            autoOk={true}
            inputVariant="outlined"
            fullWidth
          />
        </Box>
      </MuiPickersUtilsProvider>
      <Divider />
      <DialogActions style={{ justifyContent: 'space-between' }}>
        <Button color="primary" onClick={handleCloseDialog}>
          Cancel
        </Button>
        <Button color="primary" variant="contained" onClick={handleOk}>
          Ok
        </Button>
      </DialogActions>
    </>
  );
};

export default Fiscal;
